module.exports = __webpack_public_path__ + "static/media/激光切割NB-IoT气象站.9acd42fa.png";